import Swiper from 'swiper/bundle';

const FullWidthMedia = () => {
const sliders = document.querySelectorAll('.full-width-media__swiper');

    if (!sliders.length) return;

    sliders.forEach((slider) => {
        if (!(slider instanceof Element)) return;

        const swiperWrapper = slider.querySelector('.full-width-media__swiper-wrapper');
        if (!swiperWrapper) return;

        new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 10,
            loop: true,
            pagination: {
                el: slider.querySelector('.full-width-media__pagination'),
                clickable: true,
            },
            navigation: {
                nextEl: slider.querySelector('.full-width-media__nav--next'),
                prevEl: slider.querySelector('.full-width-media__nav--prev'),
            },
        });
    });
};

export default FullWidthMedia;
